module.exports = __webpack_public_path__ + "img/imgslogon2.ec5fe074.png";